import { render, staticRenderFns } from "./App2016.vue?vue&type=template&id=aebf8384&scoped=true&"
import script from "./App2016.vue?vue&type=script&lang=js&"
export * from "./App2016.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebf8384",
  null
  
)

export default component.exports